import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

const ADMIN_BASE = "/admin"

/** Segment-aware match so e.g. `/administrators` does NOT count as admin. */
export function isAdminPath(pathname: string): boolean {
  return pathname === ADMIN_BASE || pathname.startsWith(`${ADMIN_BASE}/`)
}

// Remembers the last non-admin location so "leave admin" returns there.
// Module-scoped: survives route changes, resets on a full page reload.
let lastNonAdminLocation = "/"

export function useAdminMode() {
  const location = useLocation()
  const navigate = useNavigate()
  const inAdmin = isAdminPath(location.pathname)

  useEffect(() => {
    if (!inAdmin) {
      lastNonAdminLocation = location.pathname + location.search
    }
  }, [inAdmin, location.pathname, location.search])

  const leaveTarget = lastNonAdminLocation || "/"

  // --- Want it to survive reloads (and be SSR-safe)? Swap the two lines above
  //     (the module var + effect) and `leaveTarget` for sessionStorage:
  //
  //   const KEY = 'lastNonAdminLocation';
  //   useEffect(() => {
  //     if (!inAdmin) sessionStorage.setItem(KEY, location.pathname + location.search);
  //   }, [inAdmin, location.pathname, location.search]);
  //   const leaveTarget =
  //     (typeof window !== 'undefined' && sessionStorage.getItem(KEY)) || '/';

  const enterAdmin = () => navigate(ADMIN_BASE)
  const leaveAdmin = () => navigate(leaveTarget)
  const toggleAdmin = () => (inAdmin ? leaveAdmin() : enterAdmin())

  return { inAdmin, leaveTarget, toggleAdmin }
}
